import {
    Component,
    OnInit,
    Input,
    NgModule,
    Output,
    EventEmitter,
    TemplateRef,
    Type,
    ComponentFactory,
    ViewChild,
    ViewContainerRef,
    ComponentRef,
    ContentChild
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { GridUtilService } from './share/grid-util.service';
import { API } from '../services/api';
import { DirectivesModule } from '../share/directives/yzt-directives.modules';
import { YZTViewerDirectiveModule } from '../yzt-viewer/yzt-viewer.directive';

interface PageData {
    content: Array<any>;
    numberOfElements: number;
    [portName: string]: any;
}
class GridIconIF {
    field: '';
    prop: '';
    iconTemplate: TemplateRef<any>
}

function GridIconIF_tsickle_Closure_declarations() {
/** @type {?} */
GridIconIF.prototype.field;
/** @type {?} */
GridIconIF.prototype.prop;
/** @type {?} */
GridIconIF.prototype.iconTemplate;
}


export interface PageIndexAndSize {
    first: number,
    rows: number
}
export class UIGridComponent {
     gridImg: ViewContainerRef;
private _data: PageData;
    _dataSet = [];
    _selections: any;
    _loading = false;
    _pagination = true;
    _fixScrollY = 0;
    _title = '';
    _titleTpl: TemplateRef<any>;
    _exportLoading = false;
    _editCol = false;
    //用于存放可选列
    targetColumns: any[] = [];
    //备份完整columns
    editColumns: any[] = [];
    //grid表格按钮控制
    buttonGather = {
        showEditColumn: true,
        enableExport: true,
    }
/**
 * 控制页码
 */
_first = 1;
    _rows = 10;
/**
 * 控制多选
 */
_allChecked = false;
    _indeterminate = false;
    _displayData = [];
    // 自定义图片实例
    _iconComp = {};
/**
 * @param {?} show
 * @return {?}
 */
set editCol(show: boolean) {
        if (show) {
            this.editColumns = [...this.columns, ...this.targetColumns];
        }
        this._editCol = show;
    }

     load: EventEmitter<PageIndexAndSize> = new EventEmitter();
     selectionChange: EventEmitter<any> = new EventEmitter();
     cellClick: EventEmitter<any> = new EventEmitter();
     cellOver: EventEmitter<any> = new EventEmitter();
     exportCSV: EventEmitter<any> = new EventEmitter();

     id: string;
     columns = [];
     showSizeChanger = false; // 未知用途
     pageSizeValues = [10, 30, 50, 100];
     showTitle = true;
     mulitipy = false;
/**
 * @param {?} value
 * @return {?}
 */
set data(value: any) {
        this._loading = false;
        if (!value) return;
        // 手动调用查询，解决分页问题
        // if (value.size) {
        //     this.pageRow = value.size;
        //     this.dt.first = value.number * value.size;
        // }
        let /** @type {?} */ content = value['content'] || [];
        //优化表格重复赋值性能
        for (let /** @type {?} */ row of content) {
            for (let /** @type {?} */ c of [].concat(this.columns).concat(this.targetColumns)) {
                if (c.field && row[c.field] === undefined) {
                    Object.defineProperty(row, c.field, {value: ""});
                }
            }
        }
        this._displayData = value['content'] = content;
        this._data = value;
    }
/**
 * @return {?}
 */
get data(): any {
        return this._data;
    }
/**
 * @param {?} height
 * @return {?}
 */
set fixScroll(height: any) {
        this._fixScrollY = parseInt(height);
    }
/**
 * @param {?} value
 * @return {?}
 */
set title(value: string | TemplateRef<void>) {
        if (value instanceof TemplateRef) {
            this._titleTpl = value;
        } else {
            this._title = value;
        }
    }
/**
 * @param {?} value
 * @return {?}
 */
set selection(value: Array<any>) {
        // 单选接受一个对象多选接受数组
        if (!this.util.isEqual(this._selections, value)) {
            this._selections = value;
            this.selectionChange.emit(value);
        }
    }
/**
 * @param {?} util
 * @param {?} _vcr
 * @param {?} api
 */
constructor(private util: GridUtilService,
public _vcr: ViewContainerRef,
public api: API) { }
/**
 * @return {?}
 */
ngOnInit() {
        this.onLazyLoad();
        if (this.id) {
            let /** @type {?} */ columnsMap = localStorage[this.id];
            if (columnsMap) {
                columnsMap = JSON.parse(columnsMap);
                let /** @type {?} */ sourceColumns = columnsMap["sourceColumns"];
                let /** @type {?} */ targetColumns = columnsMap["targetColumns"];
                if (sourceColumns && targetColumns && this.util.generateColumnKey([...sourceColumns, ...targetColumns]) === this.util.generateColumnKey(this.columns)) {
                    this.columns = sourceColumns;
                    this.targetColumns = targetColumns;
                }
            }
        }
        this.editColumns = this.columns;
        this.editColumns.forEach((column, i) => {
            Object.defineProperties(column, {
                title: { value: column.header },
                disabled: { value: column.transferVisabled || false }
            })
        })

    }
/**
 * @return {?}
 */
ngOnChanges() {
    }
/**
 * @return {?}
 */
ngOnDestroy() {
        if (this.id) {
            localStorage[this.id] = JSON.stringify({
                sourceColumns: this.columns,
                targetColumns: this.targetColumns
            });
        }
    }
/**
 * @param {?} change
 * @return {?}
 */
editChange(change: any) {
        let /** @type {?} */ originChange = change, /** @type {?} */
            items = originChange.list;

        items.forEach((item, index) => {
            if (change.from === 'left') {
                this.editColumns.forEach(column => {
                    if (item['field'] === column['field'] && column.direction !== 'right')
                        column.direction = 'right';
                })
            } else {
                this.targetColumns.forEach(column => {
                    if (item['field'] === column['field'] && column.direction === 'right')
                        column.direction = 'left';
                })
            }
        })

        this.columns = this.editColumns.filter(column => column.direction !== 'right');
        this.targetColumns = this.editColumns.filter(column => column.direction === 'right');
        // 重新赋值，保证穿梭框排序保持最新一次
        this.editColumns = [...this.columns, ...this.targetColumns];
    }
/**
 * @param {?=} page
 * @return {?}
 */
onLazyLoad(page: PageIndexAndSize = { first: this._first, rows: this._rows }): any {
        this._loading = true;
        this.load.emit(page);
    }
/**
 * @param {?=} isSize
 * @return {?}
 */
refreshData(isSize = false) {
        if (isSize) {
            this._first = 1;
        }
        let /** @type {?} */ page = { first: this._first, rows: this._rows };
        this.onLazyLoad(page);
    }
/**
 * @param {?} __0
 * @return {?}
 */
getIconInstance({ outField, outProp, iconTemplate }) {
        this._iconComp = {
            outField: outField || '',
            outProp: outProp || '',
            iconTemplate: iconTemplate || '',
        }
    }
/**
 * 记录选择事件
 * @param {?} data
 * @return {?}
 */
onRowSelectChange(data: any) {
        data.checked = !data.checked;

        this.mulitipy ? this.refreshStatus() : this.selection = data;

        return false;
    }
/**
 * 选择checkbox
 * @param {?=} event
 * @return {?}
 */
refreshStatus(event?: MouseEvent) {
        if (event) {
            event.stopPropagation();
        }
        const /** @type {?} */ selections = this._displayData.filter(value => value.checked === true);
        const /** @type {?} */ allChecked = this._displayData.every(value => value.checked === true);
        const /** @type {?} */ allUnChecked = this._displayData.every(value => !value.checked);
        this._allChecked = allChecked;
        this._indeterminate = (!allChecked) && (!allUnChecked);
        this.selection = selections;
    }
/**
 * 全选和反选
 * @param {?} value
 * @param {?} data
 * @return {?}
 */
checkAll(value, data: Array<any>) {
        if (value) {
            this._displayData.forEach(data => {
                data.checked = true;
            });
        } else {
            this._displayData.forEach(data => {
                data.checked = false;
            });
        }
        this.refreshStatus();
    }
/**
 * cell点击事件
 * @param {?} event
 * @param {?} row
 * @param {?} field
 * @return {?}
 */
onCellClick(event: Event, row: any, field: any) {
        event.stopPropagation();
        let /** @type {?} */ value = row[field];
        this.cellClick.emit({
            row: row,
            field: field,
            value: value,
            originalEvent: event
        });
    }
/**
 * 鼠标mouseover事件
 * @param {?} event
 * @param {?} row
 * @param {?} field
 * @return {?}
 */
onCellMouseover(event: any, row: any, field: any) {
        event.stopPropagation();
        // let value = this.value(row, field);
        let /** @type {?} */ value = row[field];
        this.cellOver.emit({
            row: row,
            field: field,
            value: value,
            originalEvent: event
        });
    }
/**
 * 数据转为字符串
 * @param {?} val
 * @return {?}
 */
dataToStr(val: any) {
        let /** @type {?} */ resultData;
        if (typeof val == 'number') {
            resultData = val.toString();
        } else if (typeof val == 'undefined') {
            resultData = '';
        } else if (val == null) {
            resultData = '';
        } else if (typeof val == 'object') {
            resultData = JSON.stringify(val);
        } else if (typeof val == 'boolean') {
            resultData = val ? '是' : '否';
        } else {
            resultData = val;
        }
        return resultData;
    }
/**
 * 对有textLength属性的column进行字节数量控制
 * @param {?} val
 * @param {?=} textLength
 * @return {?}
 */
replaceTextOmit(val: any, textLength: number = 20) {
        let /** @type {?} */ resultData, /** @type {?} */ temp;

        resultData = this.dataToStr(val);
        if (typeof resultData === 'string') {
            temp = resultData.slice(0, textLength);
            return resultData.length > textLength ? `${temp}...` : resultData;
        } else {
            return resultData;
        }
    }
/**
 *
 * @param {?} grid
 * @param {?} data
 * @param {?=} isFailed 失败了
 * @return {?}
 */
doExportCSV(grid, data, isFailed?: boolean) {
        grid.exportDisable = false;
        if (isFailed) {
            return;
        }
        let /** @type {?} */ columns = grid.columns;
        var /** @type {?} */ csv = '\ufeff';
        //headers
        for (var /** @type {?} */ i = 0; i < columns.length; i++) {
            if (columns[i].field && !columns[i].hidden) {
                csv += '"' + (columns[i].header || columns[i].field) + '"';
                if (i < (columns.length - 1)) {
                    csv += ",";
                }
            }
        }
        //body
        data.forEach(function (record, i) {
            csv += '\n';
            for (var /** @type {?} */ i_1 = 0; i_1 < columns.length; i_1++) {
                if (columns[i_1].field && !columns[i_1].hidden) {
                    let /** @type {?} */ value = Object.defineProperty(record, columns[i_1].field, null);
                    if (typeof value === 'string') {
                        value = value.replace('"', '""');
                    } else if (value === null || value === 'null' || value === 'undefined') {
                        value = "";
                    }
                    if (!isNaN(Number(value)) && value.length > 12) {
                        csv += '"' + value + '\ufeff"';
                    } else {
                        csv += '"' + value + '"';
                    }
                    if (i_1 < (columns.length - 1)) {
                        csv += ",";
                    }
                }
            }
        });
        var /** @type {?} */ blob = new Blob([csv], {
            type: 'text/csv;charset=utf-8;'
        });
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, '导出.csv');
        }
        else {
            var /** @type {?} */ link = document.createElement("a");
            link.style.display = 'none';
            document.body.appendChild(link);
            if (link.download !== undefined) {
                link.setAttribute('href', URL.createObjectURL(blob));
                link.setAttribute('download', '导出.csv');
                link.click();
            }
            else {
                csv = 'data:text/csv;charset=utf-8,' + csv;
                window.open(encodeURI(csv));
            }
            document.body.removeChild(link);
        }
    }

    exportDisable = false;
/**
 * @return {?}
 */
exportCSVIntenal() {
        let /** @type {?} */ $this = this;
        this.exportDisable = true;
        this.exportCSV.emit({
            done: $this.doExportCSV,
            grid: $this
        });
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: `yzt-grid`,
    template: './ui-grid.component.html',
    styles: [`
    :host ::ng-deep .ant-table-thead > tr > th.ant-table-selection-column, :host ::ng-deep .ant-table-tbody > tr > td.ant-table-selection-column {
        width: 20px;
        min-width: 20px;
    }
    
    .grid-border {
        border: 1px solid #e9e9e9;
    }
    .table-title {
        width: 100%;
        overflow: hidden;
        .btn-editcol {
            float: left;
        }
        .btn-export {
            float: right;
        }
    }
    
    .column-link {
        text-decoration: underline;
        color: rgba(0,0,0,0.65);
    }
    
    .edit-wrap {
        width: 600px;
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 4px;
        text-align: center;
    }
    
    .thumbnail {
        position: relative;
        overflow: hidden;
    }`]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: GridUtilService, },
{type: ViewContainerRef, },
{type: API, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'gridImg': [{ type: ViewChild, args: ['gridImg', { read: ViewContainerRef }, ] },],
'load': [{ type: Output },],
'selectionChange': [{ type: Output },],
'cellClick': [{ type: Output },],
'cellOver': [{ type: Output },],
'exportCSV': [{ type: Output },],
'id': [{ type: Input },],
'columns': [{ type: Input },],
'showSizeChanger': [{ type: Input },],
'pageSizeValues': [{ type: Input },],
'showTitle': [{ type: Input },],
'mulitipy': [{ type: Input },],
'data': [{ type: Input },],
'fixScroll': [{ type: Input },],
'title': [{ type: Input },],
'selection': [{ type: Input },],
};
}

function UIGridComponent_tsickle_Closure_declarations() {
/** @type {?} */
UIGridComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
UIGridComponent.ctorParameters;
/** @type {?} */
UIGridComponent.propDecorators;
/** @type {?} */
UIGridComponent.prototype.gridImg;
/** @type {?} */
UIGridComponent.prototype._data;
/** @type {?} */
UIGridComponent.prototype._dataSet;
/** @type {?} */
UIGridComponent.prototype._selections;
/** @type {?} */
UIGridComponent.prototype._loading;
/** @type {?} */
UIGridComponent.prototype._pagination;
/** @type {?} */
UIGridComponent.prototype._fixScrollY;
/** @type {?} */
UIGridComponent.prototype._title;
/** @type {?} */
UIGridComponent.prototype._titleTpl;
/** @type {?} */
UIGridComponent.prototype._exportLoading;
/** @type {?} */
UIGridComponent.prototype._editCol;
/** @type {?} */
UIGridComponent.prototype.targetColumns;
/** @type {?} */
UIGridComponent.prototype.editColumns;
/** @type {?} */
UIGridComponent.prototype.buttonGather;
/**
 * 控制页码
 * @type {?}
 */
UIGridComponent.prototype._first;
/** @type {?} */
UIGridComponent.prototype._rows;
/**
 * 控制多选
 * @type {?}
 */
UIGridComponent.prototype._allChecked;
/** @type {?} */
UIGridComponent.prototype._indeterminate;
/** @type {?} */
UIGridComponent.prototype._displayData;
/** @type {?} */
UIGridComponent.prototype._iconComp;
/** @type {?} */
UIGridComponent.prototype.load;
/** @type {?} */
UIGridComponent.prototype.selectionChange;
/** @type {?} */
UIGridComponent.prototype.cellClick;
/** @type {?} */
UIGridComponent.prototype.cellOver;
/** @type {?} */
UIGridComponent.prototype.exportCSV;
/** @type {?} */
UIGridComponent.prototype.id;
/** @type {?} */
UIGridComponent.prototype.columns;
/** @type {?} */
UIGridComponent.prototype.showSizeChanger;
/** @type {?} */
UIGridComponent.prototype.pageSizeValues;
/** @type {?} */
UIGridComponent.prototype.showTitle;
/** @type {?} */
UIGridComponent.prototype.mulitipy;
/** @type {?} */
UIGridComponent.prototype.exportDisable;
/** @type {?} */
UIGridComponent.prototype.util;
/** @type {?} */
UIGridComponent.prototype._vcr;
/** @type {?} */
UIGridComponent.prototype.api;
}

export class UIGridModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [
        CommonModule,
        FormsModule,
        NgZorroAntdModule,
        DirectivesModule,
        YZTViewerDirectiveModule
    ],
    declarations: [
        UIGridComponent
    ],
    exports: [UIGridComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function UIGridModule_tsickle_Closure_declarations() {
/** @type {?} */
UIGridModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
UIGridModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
